// extracted by mini-css-extract-plugin
export default {"root":"Jzu3K","left":"Rst1j","left-side-item-wrapper":"_1OJ3q","leftSideItemWrapper":"_1OJ3q","right":"d4l92","right-side-item-wrapper":"_253Ab","rightSideItemWrapper":"_253Ab"};